// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { borderRadius } from 'frontend_core/dist/styles/variables'

const LabelBorderWrapper = styled.div`
  display: inline-block;
  font-size: ${fontSize.small}px;
  border-radius: ${borderRadius}px;
  padding: ${spacing.small}px;
  box-sizing: border-box;
  line-height: 1.2;
  text-align: center;
  background: rgba(0, 0, 0, 0);
  font-weight: bold;
  position: relative;
  margin-left: ${spacing.small}px;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
      border: 1px solid ${color};
    `}
  ${mediaMin.phone`
    width: 100%;
    padding: ${spacing.small}px;
    margin-left: 0;
  `}
  ${({ newArrival }) =>
    newArrival &&
    css`
      &::before {
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 7px;
        position: absolute;
        top: -7px;
        left: -7px;
        background: ${Colors.blue};
      }
    `}
`

export type PropTypes = {
  newArrival?: boolean,
  color: string,
  children: any,
}

export default function LabelBorder(props: PropTypes) {
  return (
    <LabelBorderWrapper newArrival={props.newArrival} color={props.color}>
      {props.children}
    </LabelBorderWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/LabelBorder/index.jsx